import * as AppConstants from 'app/AppConstants';
import {
  selectDisplayName,
  selectEmail,
  isEmailValid,
  isDisplayNameValid,
  isSubmitting,
} from './inviteSelectors';
import {inviteUser as invite} from './inviteService';

export const updateDisplayName = displayName => ({
  type: AppConstants.INVITE__DISPLAY_NAME_UPDATED,
  payload: {displayName},
});

export const updateEmail = email => ({
  type: AppConstants.INVITE__EMAIL_UPDATED,
  payload: {email},
});

export const reset = () => ({
  type: AppConstants.INVITE__RESET,
});

export const inviteUser = () => (dispatch, getState) => {
  const state = getState();
  if (isSubmitting(state)) {
    return Promise.reject();
  }
  dispatch({
    type: AppConstants.INVITE__SUBMIT_STARTED,
  });

  if (!isDisplayNameValid(state) || !isEmailValid(state)) {
    dispatch({
      type: AppConstants.INVITE__SUBMIT_FAILED,
    });
    return Promise.reject();
  }

  return invite(selectDisplayName(state), selectEmail(state)).then(
    response => {
      dispatch({
        type: AppConstants.INVITE__SUBMIT_FINISHED,
        payload: {
          user: response,
        },
      });
    },
    err => {
      const body = err.response ? err.response.data : undefined;

      dispatch({
        type: AppConstants.INVITE__SUBMIT_FAILED,
      });

      if (body && body.EMAIL_DUPLICATE) {
        dispatch({
          type: AppConstants.INVITE__EMAIL_DUPLICATED,
        });
      }
      return Promise.reject();
    }
  );
};
